import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_TOKEN_USAGE_PATH,
  GetOrganizationTokenUsageErrorDto,
  GetOrganizationTokenUsageQueryParams,
  GetOrganizationTokenUsageSuccessDto,
} from '@/api/rest/resources/types/conversation';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetOrganizationTokenUsageSuccessDto;
type ErrorDto = GetOrganizationTokenUsageErrorDto;

export const useOrganizationTokenUsage = (
  organizationIdArg?: string,
  filters?: GetOrganizationTokenUsageQueryParams,
) => {
  const orgId = useOrganizationId();
  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(organizationId, 'organizationId');

  const pathVariables = { organization_id: organizationId };
  const queryParams = filters ?? undefined;

  const queryFn = () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_TOKEN_USAGE_PATH, pathVariables, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', pathVariables, 'token-usage', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
